
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import javaDatasetDescriptor from './DatasetManagementJavaDatasetDescriptor.json'
import Card from 'primevue/card'

export default defineComponent({
    components: { Card, KnValidationMessages },
    props: { selectedDataset: { type: Object as any } },
    emits: ['touched'],
    data() {
        return {
            dataset: {} as any,
            javaDatasetDescriptor,
            v$: useValidate() as any
        }
    },
    created() {
        this.dataset = this.selectedDataset
    },
    watch: {
        selectedDataset() {
            this.dataset = this.selectedDataset
        }
    },
    validations() {
        const javaClassFieldRequired = (value) => {
            return this.dataset.dsTypeCd != 'Java Class' || value
        }
        const customValidators: ICustomValidatorMap = { 'java-class-field-required': javaClassFieldRequired }
        const validationObject = { dataset: createValidations('dataset', javaDatasetDescriptor.validations.dataset, customValidators) }
        return validationObject
    },
    methods: {
        changeTypeWarning() {
            this.$store.commit('setInfo', { title: this.$t('documentExecution.registry.warning'), msg: this.$t('managers.datasetManagement.changeTypeMsg') })
        }
    }
})
